<script>
import { required } from 'vuelidate/lib/validators'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Indicators from './indicators'

import axios from 'axios'

export default {
	page: {
		title: 'Dangerous Indicators',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Indicators },
	data() {
		return {
			title: 'Dangerous Indicators',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Dangerous Indicators',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Indicators :url="'/pan/xdr/indicators?exclude=intelligence&reputation_gt=5'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
